"use strict";

export class PlayerPrefs {
    static __properties = {};
    static __expireDays = 30;

    static create(key,value) {
        let cookieValue = getCookie(key);
        if (cookieValue != null) {
            PlayerPrefs.__properties[key] = PlayerPrefs.__parseValue(value, cookieValue);
            return;
        }
        PlayerPrefs.set(key, value);
    }

    static get(key) {
        return PlayerPrefs.__properties[key];
    }
    static set(key,value) {
        PlayerPrefs.__properties[key] = value;
        setCookie(key, value, PlayerPrefs.__expireDays);
    }

    static clear(name) {   
        document.cookie = name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
    }

    static initialize(expireDays = 30, properties) {
        PlayerPrefs.__expireDays = expireDays;
        
        if (properties === undefined) return;

        for (const [key, value] of Object.entries(properties)) {
            PlayerPrefs.__properties[key] = PlayerPrefs.__validateCookie(key, value);
        }
    }

    static __validateCookie(key,value) {
        let cookieValue = getCookie(key);
        cookieValue = cookieValue != null ? PlayerPrefs.__parseValue(value, cookieValue) : value;
        return cookieValue;
    }
    static __parseValue(value,cookieValue) {
        switch (typeof value) {
            case "number":
                return parseFloat(cookieValue);
            case "boolean":
                return cookieValue == "true";
        }
        return null;
    }
}

export function getCookie(name) {
    let nameEQ = name + "=";
    let ca = document.cookie.split(";");
    for(let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == " ") c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}
export function setCookie(name,value,days) {
    let expires = "";
    if (days) {
        let date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value !== undefined ? value : "")  + expires + "; path=/";
}